import { render, staticRenderFns } from "./phRegister.vue?vue&type=template&id=75b4763e"
import script from "./phRegister.vue?vue&type=script&lang=js"
export * from "./phRegister.vue?vue&type=script&lang=js"
import style0 from "./phRegister.vue?vue&type=style&index=0&id=75b4763e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports